<template>
  <div>
    <div class="top-bar">
      <div class="top-bar-left">
        <ul class="menu">
          <router-link to="/" class="logo-link">
            <li class="menu-text">
              <img src="./../assets/logo2.svg" class="logo" alt />
              <strong>ANGIELSKI</strong> JAWORZNO
            </li>
          </router-link>
        </ul>
      </div>

      <div class="top-bar-right">
        <ul class="menu">
          <li>
            <router-link to="/" :class="{ active: currentPath=='/' }">STRONA GŁÓWNA</router-link>
          </li>
          <li>
            <router-link to="/kontakt" :class="{ active: currentPath=='/kontakt' }">KONTAKT</router-link>
          </li>
        </ul>
      </div>
      <div class="hamburger show-for-small-only" @click="toggleMenu()">
        <i class="fas fa-bars"></i>
      </div>
    </div>
    <div class="jumbo">
      <div class="orange show-for-medium">
        <span class="orange__phone animated fadeIn">
          <i class="fas fa-phone-alt fa-sm"></i> &nbsp; 511 318 138
        </span>
        <h3
          v-show="currentPath=='/'"
          class="orange__text animated fadeIn"
        >Potrzebujesz profesjonalnej pomocy z języka angielskiego? Zadzwoń i zapytaj o szczegóły!</h3>
        <h3 v-show="currentPath=='/kontakt'" class="orange__text animated fadeIn">Kontakt, mapa dojazdu</h3>
      </div>
      <a href="tel:0048511318138" class="orange show-for-small-only">
        <span class="orange__phone">
          <i class="fas fa-phone-alt fa-sm"></i> &nbsp; 511 318 138
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import sku from '@/sku'

export default {
  name: 'HeaderComponent',  
  data() {
    return {
      currentPath: this.$router.currentRoute.path
    }
  },
  methods: {
    toggleMenu() {
      document.querySelector('.top-bar-right').classList.toggle('showMenu')
    }
  },
  watch: {
    $route() {
      this.currentPath = this.$router.currentRoute.path
      document.querySelector('.orange__phone').classList.remove('fadeIn') 
    }
  },
  mounted(){
    sku.animateAutoWidthAndHeight('.orange')
  },
  updated(){
    sku.animateAutoWidthAndHeight('.orange')
    // below is to trigger phone number animation on route change
    document.querySelector('.orange__phone').classList.add('fadeIn')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo-link {
  padding: 0;
}
</style>
